import Consts from '../Const'
import { AppType, GUID, IDataResponse, mapAppTypeToServerAppType } from './ServiceTypes'

export interface IAddUpdatePlayer {
  Add: boolean
  Id: GUID
  Email: string
  Username: string
  Password?: string
  Fullname: string
  AvatarId: GUID | null
  AppType?: number //TODO Implement this when all is done
}

export default class ServicePlayer {
  static async updatePlayer(token: string, addUpdatePlayer: IAddUpdatePlayer) {
    const requestUrl = 'player'
    return await fetch(`${Consts.defaultBaseUrl}/${requestUrl}`, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        AuthorizationDeviceId: 'Editor',
        AuthorizationToken: token,
        AppType: `${mapAppTypeToServerAppType('editor')}`,
      },
      body: JSON.stringify(addUpdatePlayer)
    })
      .then(res => {
        if (res.status !== 200) {
          throw new Error('Error')
        }

        const json = res.json()
        return json
      })
      .then(responseJson => {
        return responseJson as IDataResponse
      })
  }
}
